import { Progress as AntProgress } from 'antd';
import styled from 'styled-components';
import { Color } from '../../config/Color';
import { appOverride } from '../../util/AppUtils';

export const Progress = styled(AntProgress)`
  width: 100%;
  max-width: 100%;

  ${appOverride({
    nerva: `
    @media (min-width: 600px) {
      width: 70%;
      max-width: 70vw;
      margin: 0 auto;
    }
  `,
    default: '',
  })}

  .ant-progress-success-bg,
  .ant-progress-bg {
    background-color: ${Color.flow.accent};
  }
  .ant-progress-inner {
    background-color: ${Color.decorative.muted};
  }
`;
